<template>
  <div class="mt-2">
    <b-card border-variant="primary" v-for="details in selectedOrder.detail" :key="details.id" no-body>
      <b-card-body>
        <b-row align-v="center">
          <b-col md="3" class="text-center">
            <div>
              <strong>{{details.booking.roomtypename}}</strong> <br>
              <span>{{details.booking.roomtypecode}} - {{details.booking.rateplanname}} - {{details.booking.mealplancode}} - {{details.booking.hoteldinguscode}}</span>
              <hr>
              <div>
                <strong>{{details.booking.givenname}} {{details.booking.surname}}</strong> <br/>
                {{details.booking.dateIn}} → {{details.booking.dateOut}}
              </div>
            </div>
          </b-col>

          <b-col md="" class="border-left">
            <div>
              <span>
                Código de promoción: <br><strong>{{details.booking.promotioncode}}</strong>.<br/>
                Autorizado por: <br><strong>{{details.booking.authorizationUser}}</strong> <br>
                Fecha de autorización: <br><strong>{{details.booking.dateAuthorization}}</strong>
              </span>
            </div>
          </b-col>

          <b-col md="7" class="text-center border-left">
            <div v-if="details.booking.urlauths.length>0">
              <h6>Evidencias</h6>
              <b-table
                :items="details.booking.urlauths"
                :fields="fields"
                responsive
                small
                show-empty
                empty-text="Esta orden no cuenta con archivos"
                sticky-header="400px"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" label="Loading..." variant="success"></b-spinner>
                    <strong> Cargando...</strong>
                  </div>
                </template>
                <template #cell(filename)="row">
                  <label class="text-left">
                    <strong>Nombre</strong>: {{row.item.filename}} <br> <strong>Tipo</strong>: {{replacedTypeNames(row.item.filetype)}}
                  </label>
                </template>
                <template #cell(uploadDate)="row">
                  <label class="text-left">
                    <strong>Fecha</strong>: {{row.item.uploadDate}} <br>
                    <strong>Por</strong>: {{row.item.uploaderName}} {{row.item.uploaderLastname}} 
                  </label>
                </template>
                <template #cell(actions)="row">
                <b-button
                  size="sm"
                  type="submit"
                  variant="primary"
                  title="Ver Archivo"
                  :href="fileURL + '/' + row.item.urlfile"
                  target="_blank"
                  rel="noopener noreferrer">
                  <feather-icon
                    icon="DownloadIcon"
                    size="14"
                  />
                </b-button>
              </template>
              </b-table>
            </div>
            <div v-else>
              <b-alert class="p-1" show="" variant="warning">No se han colocado evidencias</b-alert>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>
  
<script>
import { mapState } from "vuex"
  
export default {
  async mounted() {
    this.tableInfo()
  },
  data(){
    return {
      file: null,
      orderFiles: null,
      tableData: null,
      orderId: null,
      fileURL: process.env.VUE_APP_IMG_SRC_API,
      fields: [
        {key: 'filename' , label: 'Archivo'},
        {key: 'uploadDate' , label: 'Alta'},
        {key: 'actions', label: 'Acciones', class: 'text-center'}
      ],
    }
  },
  computed:{
    ...mapState('mySales', ['selectedOrder']),
    colSize(){
      const hasauthfiles = this.selectedOrder.detail.filter(detail => detail.booking?.urlauths?.length > 0)
      return hasauthfiles?.length > 1 ? '6' : '12'
    },
  },
  methods: {
    tableInfo(){
      let data = []
      this.selectedOrder?.detail?.forEach(detail => {
        detail.booking?.urlauths?.forEach(urls => {
          data.push({
            urlfile: urls?.urlfile || '',
            filename: urls?.filename || '',
            filetype: urls?.filetype || '',
            uploaduser: urls?.uploaduser || '',
            uploadDate: urls?.uploadDate || ''
          })
        })
      })
      this.tableData = data
    },
    replacedTypeNames(data){
      if (data == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'Documento Word'
      if (data == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'Documento Excel'
      if (data == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') return 'Presentación de PowerPoint'
      return data
    }
  }
}
</script>
  